export const MOYP_DETAIL_VIEW_SUCCESS = 'MOYP_DETAIL_VIEW_SUCCESS';
export const MOYP_DETAIL_VIEW_FAILURE = 'MOYP_DETAIL_VIEW_FAILURE';
